import { VisibilityState } from "@tanstack/react-table"
import { useState, useEffect } from "react"

import { LibraryResponses } from "@tfg/types/endpoints/library"

import { StandardHeaders } from "~/pages/Brand/Products/List/Components/headers.tsx"
import {
  PRODUCTS_LIST_VIEWS,
  ProductsListView,
} from "~/pages/Brand/Products/List/constants.ts"

type Props = {
  view: ProductsListView
  products: LibraryResponses.Product[]
  customHeaders: Record<string, string> | never[]
  standardHeaders: StandardHeaders[]
}

export const useColumnVisibility = ({
  view,
  products,
  customHeaders,
  standardHeaders,
}: Props) => {
  const [columnVisibility, setColumnVisibility] = useState<VisibilityState>(
    PRODUCTS_LIST_VIEWS[view]
  )

  useEffect(() => {
    setColumnVisibility(PRODUCTS_LIST_VIEWS[view])
    if (!products.some((product) => product.purchaseOrder)) {
      setColumnVisibility((visibility) => ({
        ...visibility,
        purchaseOrder: false,
      }))
    }
    if (!products.some((product) => product.brand)) {
      setColumnVisibility((visibility) => ({
        ...visibility,
        brand: false,
      }))
    }

    const visibilityCustomFields = Object.fromEntries(
      Object.entries(customHeaders).map(([customHeader]) => [
        "cfd-" + customHeader,
        view === "customFields",
      ])
    )

    const visibilityCertificates = Object.fromEntries(
      standardHeaders.map((standard) => [
        standard.name,
        view === "certificates",
      ])
    )
    setColumnVisibility((visibility) => ({
      ...visibility,
      ...visibilityCustomFields,
      ...visibilityCertificates,
    }))
  }, [view, products, customHeaders, standardHeaders])

  return { columnVisibility, setColumnVisibility }
}
